module.exports = __webpack_public_path__ + "img/sword-shield.2961f6a0.svg";